import { DragEvent } from 'react';

export const preventDropping = (e: DragEvent<HTMLInputElement>) => {
    e.preventDefault();
};
